export const HIDDEN_INPUT =
  "peer absolute inset-0 z-10 size-full cursor-pointer opacity-0 focus-visible:outline-none disabled:cursor-not-allowed";
export const BOX_BASE =
  "flex size-4 shrink-0 items-center justify-center border border-secondary-100 bg-white transition duration-150 peer-focus-visible:ring-2 peer-focus-visible:ring-primary-500 peer-focus-visible:ring-offset-2 peer-disabled:cursor-not-allowed peer-disabled:opacity-50";
export const INVALID_BOX = "border-accent_three-700";
